module.exports = __webpack_public_path__ + "media/npc_dota_hero_medusa.07f7b881.webm";